<template>
  <button
    v-show="isVisible"
    class="back-to-top"
    @click="scrollToTop"
    title="返回顶部"
  >
    <img src="../assets/imgs/scroll-up-icon.png" alt="向上箭头" class="button-icon" />
  </button>
</template>

<script>
export default {
  name: 'BackToTop',
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 当页面滚动超过300px时显示按钮
      this.isVisible = window.scrollY > 300;
    },
    scrollToTop() {
      // 平滑滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style scoped>
.back-to-top {
  /* 按钮基础样式 */
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background-color: #fff;
  /* 背景色，可根据需求改 */
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  /* 淡阴影，营造光晕感 */
  color: #333;
  /* 箭头颜色 */
  font-size: 20px;
  /* 箭头大小 */
  cursor: pointer;
  /* 鼠标悬浮变成手型 */
  display: flex;
  justify-content: center;
  align-items: center;
  /* 让箭头居中 */
  position: fixed;
  /* 固定定位，可调整显示位置 */
  bottom: 150px;
  right: 150px;
  z-index: 999;
  /* 保证在其他内容上层 */
  transition: box-shadow 0.3s ease;
  /* 阴影过渡效果 */
  cursor: pointer;
}

.back-to-top:hover {
  opacity: 1;
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.button-icon {
  width: 20px;
  height: 20px;
}

</style>    


// WEBPACK FOOTER //
// src/components/BackToTop.vue